module.exports = __webpack_public_path__ + "static/img/dawan_rdzx1.0e85a24.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dawan/dawan_rdzx1.png
// module id = 706
// module chunks = 0